
import type { MaterialPreviewEntry, ProductMediaItem } from '../interfaces';

export const isVideoMedia = (mimetype = '', url = '') =>
  mimetype.startsWith('video/') || /\.(mov|mp4|webm)(\?|$)/i.test(url);

export const getPlayableVideoUrl = (url: string) => {
  if (!/res\.cloudinary\.com\/.+\/video\/upload\//i.test(url)) return url;

  return url.replace(/\.mov(\?|$)/i, '.mp4$1');
};

export const getMaterialMediaItems = (
  priceAndImages: MaterialPreviewEntry[],
  selectedMaterial?: string | null
): ProductMediaItem[] => {
  const materialPreview =
    priceAndImages.find((item) => item.materialName === selectedMaterial && item.productImages?.length) ||
    priceAndImages.find((item) => item.productImages?.length);

  return (materialPreview?.productImages || [])
    .map((productImage, index) => {
      const image = productImage.image;
      const url = image?.publicUrl || '';

      if (!url) return null;

      return {
        id: String(image?.id || `${materialPreview?.materialName || 'material'}-${index}`),
        url,
        type: isVideoMedia(image?.mimetype, url) ? 'video' : 'image',
        materialName: materialPreview?.materialName || 'Product',
      };
    })
    .filter((item): item is ProductMediaItem => Boolean(item));
};

export const getMaterialImageIds = (priceAndImages: MaterialPreviewEntry[]) =>
  priceAndImages.flatMap((item) =>
    (item.productImages || []).map((image) => image.image?.id).filter((id): id is string => Boolean(id))
  );
